import React from 'react';
import { Tag } from "baseui/tag";
import PropTypes from 'prop-types';

const CustomTag = ({ children, color = '#004DC9', backgroundColor = '#E9F3FF', icon }) => {
    return (
        <Tag
            startEnhancer={() => icon || null}
            overrides={{
                Root: {
                    style: {
                        backgroundColor: backgroundColor,
                        color: color,
                        borderRadius: "8px",
                        border: "none",
                        width: "fit-content",
                        margin: "0px"
                    }
                }
            }}
            closeable={false}
        >
            {children}
        </Tag>
    )
}

CustomTag.propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    icon: PropTypes.node
}

export default CustomTag;